import { createSelector } from '@ngrx/store';
import { AppState } from '../index';
import * as fromRemote from './remote.reducer';

export const selectInitState = createSelector(
  (state: AppState) => state.remote,
  ({ initState }: fromRemote.State) => initState,
);

export const selectInitData = createSelector(
  (state: AppState) => state.remote,
  ({ initData }: fromRemote.State) => initData,
);

export const selectInitParams = createSelector(
  (state: AppState) => state.remote,
  ({ initData }: fromRemote.State) => initData?.result,
);

export const selectInitIsActive = createSelector(
  (state: AppState) => state.remote,
  ({ initData }: fromRemote.State) => initData?.result.status === 'IdentifierActive',
);

export const selectInitError = createSelector(
  (state: AppState) => state.remote,
  ({ initError }: fromRemote.State) => initError,
);

export const selectSendSmsTokenState = createSelector(
  (state: AppState) => state.remote,
  ({ sendSmsTokenState }: fromRemote.State) => sendSmsTokenState,
);

export const selectSendSmsTokenData = createSelector(
  (state: AppState) => state.remote,
  ({ sendSmsTokenData }: fromRemote.State) => sendSmsTokenData,
);

export const selectSendSmsTokenError = createSelector(
  (state: AppState) => state.remote,
  ({ sendSmsTokenError }: fromRemote.State) => sendSmsTokenError,
);

export const selectSendSmsTokenStatus = createSelector(
  (state: AppState) => state.remote,
  ({ sendSmsTokenData }: fromRemote.State) => sendSmsTokenData?.result.status,
);

export const selectVerifySmsTokenState = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenState }: fromRemote.State) => verifySmsTokenState,
);

export const selectVerifySmsTokenData = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => verifySmsTokenData,
);

export const selectVerifySmsTokenError = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenError }: fromRemote.State) => verifySmsTokenError,
);

export const selectVerifySmsTokenStatus = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => verifySmsTokenData?.result.status,
);

export const selectVerifySmsTokenIsOk = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => verifySmsTokenData?.result.status === 'TokenActive',
);

export const selectClientEmail = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => {
    if (verifySmsTokenData?.result) {
      return verifySmsTokenData.result.status === 'TokenActive' ? verifySmsTokenData.result.email : null;
    }

    return null;
  },
);

export const selectHashCode = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => {
    if (verifySmsTokenData?.result) {
      return verifySmsTokenData.result.hashCode;
    }

    return null;
  },
);

export const selectPathCodeName = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => {
    if (verifySmsTokenData?.result.status === 'TokenActive') {
      return verifySmsTokenData.result.pathCodeName;
    }

    return null;
  },
);

export const selectOfferValue = createSelector(
  (state: AppState) => state.remote,
  ({ verifySmsTokenData }: fromRemote.State) => {
    if (verifySmsTokenData?.result.status === 'TokenActive') {
      return verifySmsTokenData.result.offerValue;
    }

    return null;
  },
);

export const selectNavigationError = createSelector(
  (state: AppState) => state.remote,
  ({ navigationError }: fromRemote.State) => navigationError,
);

export const selectRemoteKind = createSelector(
  (state: AppState) => state.remote,
  ({ initData }: fromRemote.State) => initData?.result.salesChannel,
);

export const selectRemoteId = createSelector(
  (state: AppState) => state.remote,
  ({ remoteId }: fromRemote.State) => remoteId,
);
